import { render, staticRenderFns } from "./contextButton.vue?vue&type=template&id=67765b30&scoped=true&"
import script from "./contextButton.vue?vue&type=script&lang=js&"
export * from "./contextButton.vue?vue&type=script&lang=js&"
import style0 from "./contextButton.vue?vue&type=style&index=0&id=67765b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67765b30",
  null
  
)

export default component.exports